// eslint-disable-next-line import/prefer-default-export
export const routes = {
  flashcards: '/flashcards',
  videos: '/videos',
  video: '/video',
}
